var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import themes from '@bitcoin-portal/bitcoincom-pkg-theme';
import StickyContainer from './components/StickyContainer';
import { LOCALES } from './settings';
import Content from './components/Content';
class Navbar extends Component {
    constructor(props) {
        super(props);
        this.setContrast = (contrast) => {
            this.setState({ contrast });
        };
        this.setLocale = (locale) => {
            const { callback } = this.props;
            if (typeof callback === 'string') {
                window[callback].call(this, locale);
            }
            if (typeof callback === 'function') {
                callback(locale);
            }
            this.setState({ locale }, () => {
                this.getStrings();
            });
        };
        const { contrast = false, locale = 'en' } = props;
        this.state = {
            contrast,
            loaded: false,
            locale,
            links: [],
            buttons: [],
            social: [],
            logoUrl: 'https://www.bitcoin.com',
            country: '',
        };
    }
    componentDidMount() {
        const { locale } = this.props;
        this.setState({ loaded: true, locale });
        this.getStrings();
        this.setContrast = this.setContrast.bind(this);
        this.setLocale = this.setLocale.bind(this);
    }
    static getDerivedStateFromProps(nextProps, nextState) {
        const { isReact = true, locale } = nextProps;
        const { loaded } = nextState;
        let { contrast } = nextState;
        if (isReact && typeof nextProps.contrast !== 'undefined')
            contrast = nextProps.contrast;
        return Object.assign(Object.assign({}, nextState), { contrast,
            loaded, locale: isReact ? locale : nextState.locale });
    }
    getStrings() {
        return __awaiter(this, void 0, void 0, function* () {
            const { locale = 'en' } = this.state;
            const { links, buttons } = this.props;
            const res = LOCALES.includes(locale)
                ? yield import(`./i18n/${locale}.json`)
                : yield import('./i18n/en.json');
            this.setState({
                links: links || res.links,
                buttons: buttons || res['account-buttons'],
                logoUrl: res.logo,
            });
        });
    }
    render() {
        const { contrast, loaded, links, buttons, logoUrl } = this.state;
        const { logo } = this.props;
        const theme = themes.light;
        if (loaded)
            return (React.createElement(ThemeProvider, { theme: theme },
                React.createElement(StickyContainer, { contrast: contrast },
                    React.createElement(Content, { logo: logo, links: links, buttons: buttons, logoUrl: logoUrl, contrast: contrast }))));
        return React.createElement(React.Fragment, null);
    }
}
export default Navbar;
//# sourceMappingURL=Navbar.js.map